import { useDispatch } from "react-redux";
import { useI18N } from "@src/language/language-context";
import { updateShowOtaInstallationFailedModal } from "@src/reducers/your-reducer";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { getInstallationErrorDetails } from "@src/cloud-connect/ota-update/installation-error-details";
import { OTA_OBJECT_TYPE } from "@src/cloud-connect/ota-update/constants";

export const useOtaInstallationFailedModal = (
  activeInstallationData: ActiveInstallationProcessPayload,
) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const isBackupInstallation =
    activeInstallationData?.firmware?.type === OTA_OBJECT_TYPE.FIRMWARE_BACKUP;

  const updateDetails = activeInstallationData?.update_details ?? {};

  const errorDetails = getInstallationErrorDetails(updateDetails);

  const selectedOperationId = errorDetails?.operationId;

  const selectedErrorPayload = errorDetails?.error;

  const installationIdText = selectedOperationId
    ? i18n("modules.otaInstallationFailedModal.installationIdLabel").replace(
        "{ID}",
        String(selectedOperationId),
      )
    : "";

  const texts = {
    title: isBackupInstallation
      ? i18n("modules.otaInstallationFailedModal.titleBackup")
      : i18n("modules.otaInstallationFailedModal.titleFirmware"),
    installationDetails: installationIdText,
    subtitle: i18n("modules.otaInstallationFailedModal.subtitle"),
    installationTypeLabel: isBackupInstallation
      ? i18n("modules.otaInstallationFailedModal.installationTypeBackupLabel")
      : i18n(
          "modules.otaInstallationFailedModal.installationTypeFirmwareLabel",
        ),
    closeModalAriaLabel: isBackupInstallation
      ? i18n("modules.otaInstallationFailedModal.closeModalAriaLabelBackup")
      : i18n("modules.otaInstallationFailedModal.closeModalAriaLabelFirmware"),
    closeButtonText: i18n("modules.otaInstallationFailedModal.closeButtonText"),
  };

  const handleCloseModal = () => {
    dispatch(updateShowOtaInstallationFailedModal(false));
  };

  return {
    texts,
    errorData: {
      title: selectedErrorPayload?.title,
      detail: selectedErrorPayload?.detail,
      errorCode: selectedErrorPayload?.error_code,
      recommendedAction: selectedErrorPayload?.recommended_action,
    },
    firmwareName: activeInstallationData?.firmware?.filename,
    handleCloseModal,
  };
};
